module.exports = __webpack_public_path__ + "static/4d8bd4f0-ce40-4f34-a0b8-49bc51024ea8-1c916e9ecdd3e81b27a94b60ac595a66.woff2";